import React from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { Outlet, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../assets/boom_coloured.png";
import { useDispatch } from "react-redux";
import { setUser } from "../store/userSlice";

export default function Layout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = async () => {
    let headersList = {
      Accept: "*/*",
    };

    let response = await fetch("/auth/logout", {
      method: "GET",
      headers: headersList,
    });

    let data = await response.json();

    if (response.ok) {
      dispatch(setUser(false));
      toast.success(data.message);
      navigate("/login");
    } else {
      toast.error(data.error);
    }
  };

  return (
    <div className="mb-5">
      <div>
        <Navbar expand="lg" bg="dark" data-bs-theme="dark">
          <Container fluid className="mx-5">
            <Navbar.Brand as={Link} to="/alerts">
              <img
                width={30}
                src={logo}
                alt="Boomerang Logo"
                className="me-3"
              />
              Traffic monitoring
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                {/* <Nav.Link as={Link} to="/admin">
                  Admin
                </Nav.Link> */}
                <Nav.Link as={Link} to="/alerts">
                  Alerts
                </Nav.Link>
                <Nav.Link as={Link} to="/data">
                  Data
                </Nav.Link>
                <Nav.Link as={Link} to="/rules">
                  Rules
                </Nav.Link>
                <Nav.Link as={Link} to="/rules/new">
                  Add Rule
                </Nav.Link>
                <Nav.Link as={Link} to="/inbound-monitoring">
                  Inbound Monitoring
                </Nav.Link>
                <Nav.Link as={Link} to="/gateway-configs">
                  Gateways
                </Nav.Link>

                {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                  <NavDropdown.Item href="#action/3.2">
                    Another action
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#action/3.3">
                    Something
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="#action/3.4">
                    Separated link
                  </NavDropdown.Item>
                </NavDropdown> */}
              </Nav>
              <Nav>
                <Nav.Link as={Link} to="/users">
                  Users
                </Nav.Link>
                <Nav.Link
                  as={Button}
                  className="btn"
                  variant="link"
                  onClick={logout}
                >
                  Logout
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
      <div className="mx-5" style={{ marginBottom: 100 }}>
        <Outlet />
      </div>
    </div>
  );
}
